import { asGroupedFieldOptionsForFilter } from 'module/helpers/filter/grouped-field-transformer';
import { useTranslate } from 'module/hooks/use-translation';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { EmptyState } from 'module/ui/components/atoms/empty-state';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { useCompanyFieldsAsFilterableField } from 'helpers/fields/company-fields/fields';
import { useSignalFieldsAsFilterableField } from 'helpers/fields/signal-fields/fields';
import { AccountLayout } from '../common/layout';
import { AccountsTabs } from '../common/tab';
import { AccountsTabsType } from '../common/tab';
import { useCompanyFromUrl } from '../use-current-company';
import { AllSignalsContent } from './all-signals-content';

export const AllSignalsInsideAccount = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  const { fields: companyFields } = useCompanyFieldsAsFilterableField();
  const { fields: signalFields } = useSignalFieldsAsFilterableField();

  const groupedFields = asGroupedFieldOptionsForFilter(
    {
      [FilterGroupType.Company]: {
        fields: companyFields,
      },
      [FilterGroupType.Signal]: {
        fields: signalFields,
      },
    },
    useTranslate(),
  );

  if (isCompanyLoading) {
    return <PageLoading />;
  }

  if (company == null) {
    return <EmptyState title="No company found" />;
  }

  return (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.AllSignals} />}
      content={
        <AllSignalsContent apiFilter={null} groupedFields={groupedFields} />
      }
      actions={{}}
    />
  );
};
